<template>
  <div style="height:100%">
    <jh v-if="projectStatus" />
    <defaultLogin v-else />
  </div>
</template>

<script>
import UserApi from "@/api/UserService";
import Mobile from "@/mixin/Mobile";

import jh from "@/components/login/jh.vue";
import defaultLogin from "@/components/login/default.vue";
export default {
  props: ["qrText"],
  mixins: [Mobile],
  components: {
    jh,
    defaultLogin,
  },
  data: () => ({
    id: "",
    password: "",
    autoLogin: true,
    tempImage: "",
  }),

  computed: {
    userId() {
      return this.$store.getters.getUserList.userId;
    },
    projectStatus() {
      return this.$store.getters.getAppsetting?.projectName?.includes("jh");
    },
  },

  async created() {
    let res = await UserApi.userSession();
    if (res.data.success.includes("ok")) {
      let data = await UserApi.userInformaion({ userId: res.data.userId });
      this.$store.commit("userListChange", data.data.userInformation);
      let status;
      if (this.qrText) {
        status = {
          name: "qrCode",
          query: {
            qrText: this.qrText,
          },
        };
        return;
      } else {
        status = {
          name: "ChoiceCon",
          params: {
            loginId: this.userId,
          },
        };
      }
      this.$router.push(status);
    }
    if (this.qrText) this.$bus.$emit("dialog", "로그인 후 이용가능합니다.");
  },
};
</script>

<style scoped></style>
